import { useEffect, useRef, useState } from 'react';
import { api } from '../api.js';
import { tokens } from '../tokens.js';
import { formaterDateRelative } from '../helpers.jsx';
import { Bell, BellRing, Check } from 'lucide-react';

// Cloche notifications avec compteur. Polling toutes les 60s.
export function NotificationsBadge({ onOuvrirTicket }) {
  const [ouvert, setOuvert] = useState(false);
  const [nonLues, setNonLues] = useState(0);
  const [items, setItems] = useState([]);
  const popoverRef = useRef(null);

  // Polling du compteur
  useEffect(() => {
    let actif = true;
    async function tick() {
      try {
        const d = await api.get('/notifications/compteur');
        if (actif) setNonLues(d.non_lues || 0);
      } catch {}
    }
    tick();
    const id = setInterval(tick, 60_000);
    return () => { actif = false; clearInterval(id); };
  }, []);

  // Charger la liste a l'ouverture
  useEffect(() => {
    if (!ouvert) return;
    api.get('/notifications')
      .then(d => setItems(d.notifications || []))
      .catch(() => setItems([]));
  }, [ouvert]);

  // Fermer au clic exterieur
  useEffect(() => {
    if (!ouvert) return;
    function gestion(e) {
      if (popoverRef.current && !popoverRef.current.contains(e.target)) setOuvert(false);
    }
    document.addEventListener('mousedown', gestion);
    return () => document.removeEventListener('mousedown', gestion);
  }, [ouvert]);

  async function marquerLu(notif) {
    try { await api.post(`/notifications/${notif.id}/lu`); } catch {}
    setItems(prev => prev.map(n => n.id === notif.id ? { ...n, lu: true } : n));
    setNonLues(c => Math.max(0, c - 1));
    if (notif.ticket_token) onOuvrirTicket(notif.ticket_token);
    setOuvert(false);
  }

  async function toutLire() {
    try { await api.post('/notifications/lu-tout'); } catch {}
    setItems(prev => prev.map(n => ({ ...n, lu: true })));
    setNonLues(0);
  }

  return (
    <div ref={popoverRef} style={{ position:'relative' }}>
      <button
        onClick={() => setOuvert(o => !o)}
        style={{
          background:'transparent', border:'none', cursor:'pointer',
          padding: 6, borderRadius: 6,
          color: nonLues > 0 ? tokens.accent : tokens.inkSoft,
          position:'relative',
        }}
        title="Notifications"
      >
        {nonLues > 0 ? <BellRing size={18} /> : <Bell size={18} />}
        {nonLues > 0 && (
          <span style={{
            position:'absolute', top: -2, right: -2,
            background: tokens.danger, color: 'white',
            fontSize: 9, fontWeight: 700,
            minWidth: 16, height: 16, borderRadius: 8,
            display:'flex', alignItems:'center', justifyContent:'center',
            padding: '0 4px',
          }}>{nonLues > 99 ? '99+' : nonLues}</span>
        )}
      </button>

      {ouvert && (
        <div style={{
          position:'absolute', top: '100%', right: 0, marginTop: 6,
          background: tokens.surface,
          border: `1px solid ${tokens.border}`,
          borderRadius: 10,
          padding: 8,
          width: 360,
          maxHeight: 480, overflowY: 'auto',
          boxShadow: '0 6px 20px rgba(0,0,0,0.10)',
          zIndex: 20,
        }}>
          <div style={{
            display:'flex', alignItems:'center', justifyContent:'space-between',
            padding: '4px 6px 10px', borderBottom: `1px solid ${tokens.border}`,
            marginBottom: 4,
          }}>
            <strong style={{ fontSize: 13 }}>Notifications</strong>
            {nonLues > 0 && (
              <button
                onClick={toutLire}
                style={{
                  background:'transparent', border:'none', cursor:'pointer',
                  color: tokens.accent, fontSize: 11, fontWeight: 500,
                  display:'flex', alignItems:'center', gap: 4,
                }}
              >
                <Check size={12} /> Tout lire
              </button>
            )}
          </div>

          {items.length === 0 ? (
            <div style={{ padding: 24, textAlign:'center', color: tokens.inkMuted, fontSize: 12 }}>
              Aucune notification
            </div>
          ) : (
            items.map(n => (
              <button
                key={n.id}
                onClick={() => marquerLu(n)}
                style={{
                  display:'flex', flexDirection:'column', gap: 2,
                  width: '100%',
                  background: n.lu ? 'transparent' : tokens.accentBg,
                  border: 'none', padding: '8px 10px', borderRadius: 6,
                  textAlign: 'left', cursor:'pointer',
                  marginBottom: 2,
                }}
              >
                <span style={{ fontSize: 12, color: n.lu ? tokens.inkSoft : tokens.ink }}>
                  {n.contenu_court}
                </span>
                <span style={{ fontSize: 10, color: tokens.inkMuted }}>
                  {formaterDateRelative(n.fait_le)} · #{n.ticket_token}
                </span>
              </button>
            ))
          )}
        </div>
      )}
    </div>
  );
}
